module.exports = __webpack_public_path__ + "static/aside-lightning-40507a043cab0837d91a1f9eda715058.jpg";